var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 246 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_11943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7246 167.588H191.903L228.004 37.6445H64.8252L28.7246 167.588Z",
    fill: "#FAD2FB",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6106 51.0129C100.691 51.0129 102.377 49.3324 102.377 47.2594C102.377 45.1864 100.691 43.5059 98.6106 43.5059C96.5302 43.5059 94.8438 45.1864 94.8438 47.2594C94.8438 49.3324 96.5302 51.0129 98.6106 51.0129Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.718 51.0129C87.7984 51.0129 89.4849 49.3324 89.4849 47.2594C89.4849 45.1864 87.7984 43.5059 85.718 43.5059C83.6377 43.5059 81.9512 45.1864 81.9512 47.2594C81.9512 49.3324 83.6377 51.0129 85.718 51.0129Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8235 51.0129C74.9039 51.0129 76.5904 49.3324 76.5904 47.2594C76.5904 45.1864 74.9039 43.5059 72.8235 43.5059C70.7431 43.5059 69.0566 45.1864 69.0566 47.2594C69.0566 49.3324 70.7431 51.0129 72.8235 51.0129Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.311 57.7266H59.1328",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2695 155.037H181.448L217.549 25.1016H54.3701L18.2695 155.037Z",
    fill: "#FAD2FB",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1555 38.4622C90.2359 38.4622 91.9224 36.7816 91.9224 34.7086C91.9224 32.6356 90.2359 30.9551 88.1555 30.9551C86.0752 30.9551 84.3887 32.6356 84.3887 34.7086C84.3887 36.7816 86.0752 38.4622 88.1555 38.4622Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.263 38.4622C77.3434 38.4622 79.0298 36.7816 79.0298 34.7086C79.0298 32.6356 77.3434 30.9551 75.263 30.9551C73.1826 30.9551 71.4961 32.6356 71.4961 34.7086C71.4961 36.7816 73.1826 38.4622 75.263 38.4622Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3684 38.4622C64.4488 38.4622 66.1353 36.7816 66.1353 34.7086C66.1353 32.6356 64.4488 30.9551 62.3684 30.9551C60.288 30.9551 58.6016 32.6356 58.6016 34.7086C58.6016 36.7816 60.288 38.4622 62.3684 38.4622Z",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.856 45.1836H48.6777",
    stroke: "#020018",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4 25.1016L190.924 44.8201",
    stroke: "#0C0F10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.867 31.791L207.393 39.1327",
    stroke: "#0C0F10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.393 31.791L199.867 39.1327",
    stroke: "#0C0F10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.142 73.0293C108.467 78.5108 102.194 82.132 95.0837 82.132C87.9731 82.132 81.7088 78.5191 78.0332 73.0293",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.793 73.0293C154.117 78.5108 147.845 82.132 140.734 82.132C133.623 82.132 127.359 78.5191 123.684 73.0293",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.375 93.7229L58.5342 88.043L61.0067 93.7312L54.4354 107.199L54.6428 107.671L65.4207 103.016L66.8644 106.331L53.2323 112.21L50.7598 106.521L57.3311 93.0532L57.1237 92.5819L46.8187 97.03L45.375 93.7146V93.7229Z",
    fill: "white",
    stroke: "#0C0F10",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.546875 62.5785L18.6428 54.377L22.2105 62.1982L13.4405 81.0238L13.7392 81.677L28.5661 74.9553L30.6487 79.5191L11.9056 88.0183L8.33783 80.197L17.1078 61.3714L16.8091 60.7183L2.63774 67.1423L0.555172 62.5785H0.546875Z",
    fill: "white",
    stroke: "#0C0F10",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2025 11.0625L39.6433 15.0971L37.8843 21.7692L22.8417 29.0696L22.6924 29.6235L35.3454 32.9306L34.3249 36.8247L18.3281 32.6495L20.0871 25.9775L35.1297 18.6771L35.2791 18.1231L23.1902 14.9649L24.2108 11.0708L24.2025 11.0625Z",
    fill: "white",
    stroke: "#0C0F10",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.669 108.637C121.254 109.811 120.69 110.869 120.026 111.795C117.819 114.887 114.484 116.45 111.596 115.425C109.813 114.796 108.527 113.283 107.871 111.34C107.124 109.183 107.149 106.487 108.103 103.825C109.92 98.7487 114.426 95.7061 118.176 97.0372C121.926 98.3683 123.486 103.56 121.677 108.637H121.669Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.026 111.796C117.819 114.888 114.484 116.45 111.596 115.425C109.813 114.797 108.527 113.284 107.871 111.341C110.078 108.249 113.414 106.678 116.301 107.703C118.085 108.331 119.371 109.844 120.026 111.796Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34 113.35C122.523 118.426 118.018 121.469 114.268 120.137",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.574 155.178L158.781 156.046L29.9023 162.147L31.8439 155.178H177.574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.485 62.5374C232.109 62.5374 245.586 49.1081 245.586 32.5422C245.586 15.9762 232.109 2.54688 215.485 2.54688C198.86 2.54688 185.383 15.9762 185.383 32.5422C185.383 49.1081 198.86 62.5374 215.485 62.5374Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.655 60.4046C229.279 60.4046 242.756 46.9753 242.756 30.4093C242.756 13.8434 229.279 0.414062 212.655 0.414062C196.03 0.414062 182.553 13.8434 182.553 30.4093C182.553 46.9753 196.03 60.4046 212.655 60.4046Z",
    fill: "#DDF933",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.238 15.2793H217.385V45.5391H224.238V15.2793Z",
    fill: "#0C0F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.918 15.2793H201.064V45.5391H207.918V15.2793Z",
    fill: "#0C0F10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_11943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 168,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.546adc708c95996669dfeae14278e801.svg";
export { ForwardRef as ReactComponent };